module.exports = __webpack_public_path__ + "media/images/logo_bizjumping-395be057a907387c77e338e8574beaee.png";